const Environment = process.env.REACT_APP_MODE;

const config = require(`./${Environment}`);
export default { ...config }.default;